import { AxiosResponse } from 'axios';
import api from '../../app/axios';

export interface IVideoStreamData {
  name: string;
  file: File;
  account: any;
  description: string;
}

export const uploadVideoStreamApi = (data: any): Promise<AxiosResponse> => {
  return api.post('videocontent/upload', data);
};

export const removeVideoStreamApi = (data: any): Promise<AxiosResponse> => {
  return api.post('videocontent/remove', data);
};

export const readAvailableStreamsApi = (data: any): Promise<AxiosResponse> => {
  return api.post('videocontent/list', data);
};

export const playVideoStreamReqTokenApi = (
  data: any
): Promise<AxiosResponse> => {
  return api.post('videocontent/req_play_token', data);
};
